var popupStyles = {
  root: function root() {
    return {};
  },
  popup: function popup(_ref) {
    var v = _ref.variables;
    return {
      zIndex: v.zIndex,
      position: 'absolute',
      textAlign: 'left',
      color: v.contentColor,
      background: v.contentBackgroundColor
    };
  }
};
export default popupStyles;